<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='8'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span='16'>
            <a-button style='margin-left: 20px' type='primary' @click='lookSevenDays'>查看近7天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookTwoWeeks'>查看近14天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookOneMonth'>查看近30天数据</a-button>
          </a-col>
        </a-row>
        <!--          <a-col :md="6" :sm="8">-->
        <!--            <a-form-item :label="'产品类型'">-->
        <!--              <a-select-->
        <!--                v-model="queryParam.appssid"-->
        <!--                @change="onChange"-->
        <!--              >-->
        <!--                <a-select-option v-for="item in appList" :key="item.appssid">-->
        <!--                  {{ item.appName }}-->
        <!--                </a-select-option>-->
        <!--              </a-select>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <a-row :gutter='24'>
          <a-col :md='4' :sm='4'>
            <a-button type='primary' @click='VisualChart' icon='bar-chart'
                      style='margin-left: 10px'>查看可视化图表
            </a-button>
          </a-col>
          <a-col :md='4' :sm='4'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click="downLoadData('')" icon='download'
                        style='margin-left: 8px'>导出</a-button>
              <!--              <a-button type="primary" @click="downLoadData2('')" icon="download2" style="margin-left: 8px">导出2</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>

    </div>
    <RefundTradeModal ref='modalForm' @ok='modalFormOk'></RefundTradeModal>
    <!--  可视化弹窗  -->
    <branchallcountListForAppModal ref='branchallcountListForAppModal'></branchallcountListForAppModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAppAllCountForAppssid, getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import branchallcountListForAppModal
  from '@/views/webpublic/platformOrder/ChartsModal/branchallcountListForAppModal.vue'

export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict,
    branchallcountListForAppModal
  },
  data() {
    return {
      visible: false,
      REFUND_TRADE_STATUS,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        dataDt: [moment().add('days', 0), moment().add('days', 0)],
        appssid: ''
      },
      loading: false,
      // 表头
      columns: [
        // {
        //   title: '日期',
        //   align: 'left',
        //   dataIndex: 'datadt'
        // },
        {
          title: '产品',
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: '花费',
          align: 'left',
          dataIndex: 'fee'
        },

        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs'
        },
        {
          title: '注册',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: '申贷',
          align: 'left',
          dataIndex: 'subCount'
        },
        {
          title: '通过',
          align: 'left',
          dataIndex: 'approvalCount'
        },
        {
          title: '放款',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: '安装-注册转化率',
          align: 'left',
          dataIndex: 'irRate'
        },
        {
          title: '注册-申请转化率',
          align: 'left',
          dataIndex: 'rsRate'
        },
        {
          title: '申请-通过转化率',
          align: 'left',
          dataIndex: 'saRate'
        },
        // {
        //   title: '申请-放款转化率',
        //   align: 'left',
        //   dataIndex: 'slRate'
        // },
        {
          title: '通过-放款转化率',
          align: 'left',
          dataIndex: 'alRate'
        },
        {
          title: '安装成本',
          align: 'left',
          dataIndex: 'installFee'
        },
        {
          title: '申贷成本',
          align: 'left',
          dataIndex: 'subFee'
        },
        {
          title: '通过成本',
          align: 'left',
          dataIndex: 'approvalFee'
        },
        {
          title: '放款成本',
          align: 'left',
          dataIndex: 'loanFee'
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.loadData(1)
    getApplist().then(res => {
      this.appList = res.data || []
    })
  },
  methods: {
    VisualChart() {
      console.log('点击了查看可视化图片')
      var paramsecharts = this.getQueryParams()
      console.log('paramsecharts', paramsecharts)
      //点击的时候查询一下，少于一条数据弹出查出0条数据的弹窗
      getAppAllCountForAppssid(Object.assign({}, paramsecharts)).then((res) => {
        if (res.code === 1000) {
          console.log('准备发数据咯！', res.data.rows.length)
          if (res.data.rows.length) {
            this.$refs.branchallcountListForAppModal.sendRequest(paramsecharts)
            this.$refs.branchallcountListForAppModal.openModal()
            this.$refs.branchallcountListForAppModal.clearEcharts()
          } else {
            this.$message.error(' 查到0条数据！')
          }
        } else {
        }

      }).catch(e => {

      })

    },
    lookSevenDays() {
      console.log('查看七天')
      this.queryParam.dataDt = [moment().add('days', -6), moment().add('days', 0)]
      this.loadData()
    },
    lookTwoWeeks() {
      console.log('查看两周')
      this.queryParam.dataDt = [moment().add('days', -13), moment().add('days', 0)]
      this.loadData()
    },
    lookOneMonth() {
      console.log('查看一个月')
      this.queryParam.dataDt = [moment().add('days', -29), moment().add('days', 0)]
      this.loadData()
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getAppAllCountForAppssid(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          console.log('res---->', res.data)
          // 使用filter()方法过滤数组，只保留installs属性值大于200的对象
          var filteredRes = res.data.rows.filter(function(item) {
            return item.installs > 200
          })
          console.log('filteredRes---->', filteredRes)

          // this.ipagination.total = res.data.total
          // this.dataSource = res.data.rows
          this.ipagination.total = filteredRes.length
          this.dataSource = filteredRes
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1])
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = '新增'
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // model回调
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/webpublic/statistics/appAllCountForAppExcel?startDate=' + params.startDate + '&endDate=' + params.endDate,
        fileName: 'countLoanDataWithDateForAppExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    downLoadData2(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' + params.startDate + '&endDate=' + params.endDate + '&appssid=' + params.appssid,
        fileName: 'countLoanDataWithDateExcelColor.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
